import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons'
import { Button, Flex, Text } from '@mantine/core'
import { useRouter } from 'next/router'

import { useTranslation } from '@flecto/translations'
import { Modal } from '@flecto/ui'

import { useModalNoContractTemplate } from '../../hooks/useModalNoContractTemplate'

export function ModalNoContractTemplate() {
  const { closeModal } = useModalNoContractTemplate()
  const { t } = useTranslation('saas', { keyPrefix: 'booking_actions' })

  const router = useRouter()

  return (
    <Modal>
      <Modal.Icon icon={faTriangleExclamation} color='orange' />

      <Modal.Title>{t('modal_action_configure_contract_title')}</Modal.Title>

      <Modal.Content>
        <Text c='dimmed'>
          {t('modal_action_configure_contract_description')}
        </Text>
      </Modal.Content>

      <Modal.FooterExtra>
        <Flex gap='md' w='100%' justify='flex-end'>
          <Modal.Cancel />
          <Button
            onClick={async () => {
              await router.push('/profile/bookings')
              closeModal()
            }}
          >
            {t('modal_action_configure_contract_button')}
          </Button>
        </Flex>
      </Modal.FooterExtra>
    </Modal>
  )
}
